import React from "react";
import {
  Typography,
  Radio,
  TextField,
  FormControlLabel,
  Grid,
  Box,
} from "@mui/material";
import { ErpSaveUpdateButton } from "app/shared/ReuseComponents/ButtonComponent";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const validationSchema = yup.object({
  status_btn: yup.string().nullable().required("Approval is required"),
  comments: yup
    .string()
    .min(5, "Comments must be at least 5 characters")
    .required("Comments are required"),
});

const ApprovalForm = ({
  approvalData,
  onChange,
  onSubmit,
  isSubmitting,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: approvalData,
  });

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubmit)}>
      <Grid container spacing={3} sx={{ mt: 2 }}>
        {/* LEFT FORM */}
        <Grid item xs={12} md={7}>
          <Typography variant="h6" gutterBottom>
            Approve <span style={{ color: "red" }}>*</span>
          </Typography>

          <Box>
            <FormControlLabel
              control={
                <Radio
                  size="small"
                  value="yes"
                  {...register("status_btn")}
                  checked={approvalData.status_btn === "yes"}
                  onChange={(e) =>
                    onChange("status_btn", e.target.value)
                  }
                />
              }
              label="Yes"
            />

            <FormControlLabel
              control={
                <Radio
                  size="small"
                  value="no"
                  {...register("status_btn")}
                  checked={approvalData.status_btn === "no"}
                  onChange={(e) =>
                    onChange("status_btn", e.target.value)
                  }
                />
              }
              label="No"
            />

            <Typography color="error" variant="body2">
              {errors.status_btn?.message}
            </Typography>
          </Box>

          <Box sx={{ mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              Enter your Comments <span style={{ color: "red" }}>*</span>
            </Typography>

            <TextField
              fullWidth
              className="multiline-box"
              rows={4}
              multiline
              {...register("comments")}
              value={approvalData.comments || ""}
              onChange={(e) =>
                onChange("comments", e.target.value)
              }
              placeholder="Enter your comments here..."
              error={!!errors.comments}
              helperText={errors.comments?.message}
            />
          </Box>
        </Grid>

        {/* RIGHT BUTTON */}
        {!approvalData.OneTimeApproved_flg && (
          <Grid
            item
            xs={12}
            md={5}
            display="flex"
            alignItems={{ xs: "center", md: "flex-end" }}
            justifyContent={{ xs: "center", md: "flex-end" }}
          >
            <ErpSaveUpdateButton
              name="Submit"
              type="submit"
              loading={isSubmitting}
              disabled={isSubmitting}
              width="120px"
            />
          </Grid>
        )}
      </Grid>
    </form>
  );
};

export default ApprovalForm;
